
import { Component, Vue } from 'vue-property-decorator'
import { isNewViewRoute, isLegacyViewRoute, getTargetRoute, persistViewPreference } from '@/utils/viewVersionSwitcher'
import { filteroutRedirected } from '@/utils/routing'

@Component
export default class ViewVersionSwitcher extends Vue {
	get currentRouteName(): string {
		return this.$route.name ?? ''
	}

	get isOnNewView(): boolean {
		return isNewViewRoute(this.currentRouteName)
	}

	get isOnLegacyView(): boolean {
		return isLegacyViewRoute(this.currentRouteName)
	}

	get shouldShow(): boolean {
		return this.isOnNewView || this.isOnLegacyView
	}

	get targetRoute(): string {
		return getTargetRoute(this.currentRouteName)
	}

	get buttonLabel(): string {
		if (this.isOnNewView) return this.$t('viewButtons.old').toString()
		if (this.isOnLegacyView) return this.$t('viewButtons.new').toString()
		return ''
	}

	get buttonIcon(): string {
		return this.isOnNewView ? 'history' : 'new_releases'
	}

	async switchView(): Promise<void> {
		if (!this.targetRoute) return
		persistViewPreference(this.currentRouteName, this.targetRoute)
		// the target page may redirect to add its query defaults (cargo.projects-old adds transportationType)
		await this.$router.push({ name: this.targetRoute }).catch(filteroutRedirected)
	}
}
